import { getAllPortalNavItems } from '../config/portalNavigation';

const NAV_TITLE_MAP = Object.fromEntries(
  getAllPortalNavItems().map((item) => {
    const base = item.href.split('?')[0];
    return [base, item.name];
  }),
);

const DYNAMIC_TITLES = [
  { pattern: /^\/portal\/employees\/[^/]+$/, title: 'Employee profile' },
  { pattern: /^\/portal\/recruitment\/[^/]+$/, title: 'Applicant profile' },
  { pattern: /^\/portal\/service-users\/[^/]+$/, title: 'Service user profile' },
  { pattern: /^\/portal\/forms\/[^/]+$/, title: 'Form editor' },
];

export function resolveWorkspaceWindowTitle(pathname, search = '') {
  const path = (pathname || '/portal/dashboard').split('?')[0];
  const query = search || '';

  if (query.includes('tab=incidents')) return 'Incidents';
  if (path === '/portal/compliance-centre' && query.includes('tab=reports')) return 'Compliance reports';

  const withQuery = query ? `${path}?${query.replace(/^\?/, '')}` : path;
  if (NAV_TITLE_MAP[withQuery]) return NAV_TITLE_MAP[withQuery];
  if (NAV_TITLE_MAP[path]) return NAV_TITLE_MAP[path];

  for (const rule of DYNAMIC_TITLES) {
    if (rule.pattern.test(path)) return rule.title;
  }

  const segment = path.split('/').filter(Boolean).pop();
  if (!segment) return 'Workspace';
  return segment.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function splitWorkspacePath(fullPath) {
  const raw = fullPath || '/portal/dashboard';
  const [pathname, search = ''] = raw.split('?');
  return {
    pathname: pathname || '/portal/dashboard',
    search: search ? `?${search}` : '',
  };
}

export function joinWorkspacePath(pathname, search = '') {
  const cleanSearch = search && !search.startsWith('?') ? `?${search}` : search;
  return `${pathname || '/portal/dashboard'}${cleanSearch || ''}`;
}

/**
 * Normalize legacy or malformed workspace paths before routing a window.
 */
export function normalizeWorkspaceEntry(pathname = '/portal/dashboard', search = '') {
  const path = pathname || '/portal/dashboard';
  const cleanSearch = search && !search.startsWith('?') ? `?${search}` : (search || '');

  const inboxDeptMatch = path.match(/^\/portal\/inbox\/department-(.+)$/);
  if (inboxDeptMatch) {
    return {
      pathname: '/portal/inbox',
      search: `?department=${inboxDeptMatch[1]}`,
    };
  }

  return { pathname: path, search: cleanSearch };
}